import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { cartReducer } from '../reducers/cartReducers';
import { subCategoryListReducer } from '../reducers/categoyReducers';
import { productDeleteReducer, productDetailsReducer, productListReducer, productSuspendReducer } from '../reducers/productReducers';
import { userDeleteReducer, userDetailsReducer, userListReducer, userLoginReducer, userRegisterReducer, userSuspendReducer, userUpdateProfileReducer, userUpdateRoleReducer } from '../reducers/userReducers';
import { vendeurOrdersReducer } from '../reducers/vendeurReducers';
import { favoriteReducer } from '../reducers/favoriteReducers';
import { orderReducer, shippingEstimateReducer } from '../reducers/orderReducers';

// Combine all reducers
const reducer = combineReducers({
  productList: productListReducer,
  productDetails: productDetailsReducer,
  productDelete: productDeleteReducer,
  productSuspend: productSuspendReducer,
  userUpdateRole: userUpdateRoleReducer,
  cart: cartReducer,
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userDetails: userDetailsReducer,
  order: orderReducer,
  userUpdateProfile: userUpdateProfileReducer,
  vendeurOrders: vendeurOrdersReducer,
  categoryList: subCategoryListReducer,
  userSuspend: userSuspendReducer,
  userList: userListReducer,
  userDelete: userDeleteReducer,
  favoris: favoriteReducer,
shippingEstimate: shippingEstimateReducer, 
  

});

// Récupérer l'utilisateur connecté depuis le localStorage
const userInfoFromStorage = localStorage.getItem('userInfo')
  ? JSON.parse(localStorage.getItem('userInfo'))
  : null;

const cartItemsFromStorage = localStorage.getItem('cartItems')
  ? JSON.parse(localStorage.getItem('cartItems'))
  : [];

const shippingAddressFromStorage = localStorage.getItem('shippingAddress')
  ? JSON.parse(localStorage.getItem('shippingAddress'))
  : {};

const paymentMethodFromStorage = localStorage.getItem('paymentMethod')
  ? JSON.parse(localStorage.getItem('paymentMethod'))
  : null;
  
  
  


const initialState = {

  
  userLogin: { userInfo: userInfoFromStorage },
  cart: {
    cartItems: cartItemsFromStorage,
    shippingAddress: shippingAddressFromStorage,
    paymentMethod: paymentMethodFromStorage,
  },
  
};



const middleware = [thunk];

// Création du store
const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
